import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { hydrateOptions } from "@/lib/leadMeta";

const OptionsContext = createContext({ ready: false, options: null, reload: () => {} });
export const useOptions = () => useContext(OptionsContext);

export function OptionsProvider({ children }) {
  const [ready, setReady] = useState(false);
  const [options, setOptions] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/options");
      hydrateOptions(data);
      setOptions(data);
    } catch {
      // fall back to bundled defaults
    }
    setReady(true);
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <OptionsContext.Provider value={{ ready, options, reload }}>
      {children}
    </OptionsContext.Provider>
  );
}
